import { Component } from "react";
import { connect } from "react-redux";
import { synchroniseArOrSppInError, deleteArOrPps } from "../../../redux/analyseRisques/analyseRisquesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import "../../../utils.css";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class AnalyseRisquesInError extends Component {
    synchronise() {
        this.props.synchroniseArOrSppInError(
            this.props.analyseRisques.header.mobileId,
            this.props.analyseRisques.header.id,
            this.props.analysesRisques.moduleSpp,
            this.props.activeUser,
            this.props.subcontractors
        );
    }

    deleteArOrPps() {
        this.props.deleteArOrPps(this.props.analyseRisques, this.props.activeUser, this.props.analysesRisques);
    }

    render() {
        let deleteBtnElement = <div></div>;

        if (!this.props.analyseRisques.header.validationInProgress)
            deleteBtnElement = (
                <div>
                    <Fab onClick={this.deleteArOrPps.bind(this)} className="red-button div-center">
                        <Icon>delete</Icon>
                    </Fab>
                    <span className="floating-btn-text span-center">Supprimer</span>
                </div>
            );

        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-4 col-4">{deleteBtnElement}</div>
                    <div className="offset-lg-8 col-lg-2 offset-md-8 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4">
                        <div className="center">
                            <Fab onClick={this.synchronise.bind(this)} color="primary" className="div-center">
                                <Icon>send</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">{"Synchroniser"}</span>
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
        activeUser: state.activeUser,
        subcontractors: state.tiers.subcontractors,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        synchroniseArOrSppInError: (guid, id, moduleSpp, user, subcontractors) =>
            dispatch(synchroniseArOrSppInError(guid, id, moduleSpp, user, subcontractors)),
        deleteArOrPps: (analyseRisques, activeUser, analysesRisquesState) =>
            dispatch(deleteArOrPps(analyseRisques, activeUser, analysesRisquesState)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AnalyseRisquesInError);
